/**
 * Reads the current user JWT.
 *
 * `window.LumappsContext.token` is the single source of truth: it is server-rendered into the
 * page and rewritten on every refresh. We read it on each call rather than keeping a copy, so
 * this module can never serve a token that has already been replaced. An empty string means
 * the user is not connected and is normalised to `undefined`.
 */
export function getUserToken(): string | undefined {
    return window.LumappsContext?.token || undefined;
}
